import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import { validateEndDate, validateStartDate } from "../utils/validationUtils";

dayjs.extend(utc);

export function UpsertProjectRecord(scenarioID, mode, values?, projectData?): any {
    const customParseFormat = require('dayjs/plugin/customParseFormat')
    dayjs.extend(customParseFormat)
    if (mode == 'editing') {
        return {
            // editing scenario project
            inSourceID: values.SourceID,
            inScenarioID: scenarioID,
            inEditedProject: 1,
            inScenarioProjID: projectData.ScenarioProjID ?? 0,
            inRemoveProjectFromModel: projectData.RemoveProjectFromModel ?? 0,
            inProjID: projectData.ProjID,
            inProjectName: values.ProjectName,
            inLocationID: values.LocationID ?? "",
            inState: values.State,
            inSource: values.Source,
            inInvestment: Number(values.Investment).toString(10),
            inRawProjectType: values.RawProjectType,
            inProjectStage: values.ProjectStage,
            inStartDateConstruction: validateStartDate(values.StartDateConstruction, values.ProcessingPath),
            inEndDateConstruction: validateEndDate(values.EndDateConstruction, values.ProcessingPath),
            inFundingMode: values.FundingMode,
            inStartYear: Number(projectData.PeriodStartYear),
            inEndYear: Number(projectData.PeriodEndYear),
            inKM: (values.km ? values.km : projectData.km ?? 0).toString(),
            inMW: (values.MW ? values.MW : projectData.MW ?? 0).toString(),
            inM2: (values.M2 ? values.M2 : projectData.M2 ?? 0).toString(),
            inProcessingPath: values.ProcessingPath
        };
    } else if (mode == 'deleting') {
        return {
            // deleting scenario project
            inSourceID: values.SourceID,
            inScenarioID: scenarioID,
            inEditedProject: 1,
            inScenarioProjID: values.ScenarioProjID ?? 0,
            inRemoveProjectFromModel: 1,
            inProjID: values.ProjID,
            inProjectName: values.ProjectName,
            inState: values.State,
            inSource: values.Source,
            inLocationID: values.LocationID ?? "",
            inInvestment: Number(values.Investment).toString(10),
            inRawProjectType: values.RawProjectType,
            inProjectStage: values.ProjectStage,
            inStartDateConstruction: dayjs.utc(values.StartDateConstruction, "DD/MM/YYYY"),
            inEndDateConstruction: dayjs.utc(values.EndDateConstruction, "DD/MM/YYYY"),
            inFundingMode: values.FundingMode,
            inStartYear: Number(dayjs(values.PeriodStartYear, "DD/MM/YYYY").year()),
            inEndYear: Number(dayjs(values.PeriodEndYear, "DD/MM/YYYY").year()),
            inKM: (values.km ?? 0).toString(),
            inMW: (values.MW ?? 0).toString(),
            inM2: (values.M2 ?? 0).toString(),
            inProcessingPath: values.ProcessingPath
        };
    } else if (mode == 'restoring') {
        return {
            // deleting scenario project
            inSourceID: values.SourceID,
            inScenarioID: scenarioID,
            inEditedProject: 1,
            inScenarioProjID: values.ScenarioProjID ?? 0,
            inRemoveProjectFromModel: 0,
            inProjID: values.ProjID,
            inProjectName: values.ProjectName,
            inState: values.State,
            inSource: values.Source,
            inLocationID: values.LocationID ?? "",
            inInvestment: Number(values.Investment).toString(10),
            inRawProjectType: values.RawProjectType,
            inProjectStage: values.ProjectStage,
            inStartDateConstruction: dayjs.utc(values.StartDateConstruction, "DD/MM/YYYY"),
            inEndDateConstruction: dayjs.utc(values.EndDateConstruction, "DD/MM/YYYY"),
            inFundingMode: values.FundingMode,
            inStartYear: Number(dayjs(values.PeriodStartYear, "DD/MM/YYYY").year()),
            inEndYear: Number(dayjs(values.PeriodEndYear, "DD/MM/YYYY").year()),
            inKM: (values.km ?? 0).toString(),
            inMW: (values.MW ?? 0).toString(),
            inM2: (values.M2 ?? 0).toString(),
            inProcessingPath: values.ProcessingPath
        };
    } else {
        return {
            // creating scenario project
            inSourceID: values.SourceID,
            inScenarioID: scenarioID,
            inEditedProject: 1,
            inScenarioProjID: 0,
            inRemoveProjectFromModel: 0,
            inProjID: 0,
            inProjectName: values.ProjectName,
            inState: values.State,
            inSource: values.Source,
            inLocationID: values.LocationID ?? "",
            inInvestment: Number(values.Investment).toString(10),
            inRawProjectType: values.RawProjectType,
            inProjectStage: values.ProjectStage,
            inStartDateConstruction: dayjs.utc(values.StartDateConstruction),
            inEndDateConstruction: dayjs.utc(values.EndDateConstruction),
            inFundingMode: values.FundingMode,
            inStartYear: null,
            inEndYear: null,
            inKM: (values.km ?? 0).toString(),
            inMW: (values.MW ?? 0).toString(),
            inM2: (values.M2 ?? 0).toString(),
            inProcessingPath: values.ProcessingPath
        };
    }
}
